import { render, staticRenderFns } from "./StockNote.vue?vue&type=template&id=fe5a5842&scoped=true&"
import script from "./StockNote.vue?vue&type=script&lang=js&"
export * from "./StockNote.vue?vue&type=script&lang=js&"
import style0 from "./StockNote.vue?vue&type=style&index=0&id=fe5a5842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5a5842",
  null
  
)

export default component.exports